/**
 * Web Style Import
 *
 */

import './style/dnb-breadcrumb.scss'
